import AssociatesFilters from './FiltersPage';

export default AssociatesFilters;
